import {createAction} from '@reduxjs/toolkit'
import {DownloadAnalyticsLogsAction} from 'interfaces'

// analytics log download actions
export const downloadAnalyticsLogs = createAction<DownloadAnalyticsLogsAction>(
  'downloadAnalyticsLogs',
)
export const downloadAnalyticsLogsSuccess = createAction<string>(
  'downloadAnalyticsLogsSuccess',
)
export const downloadAnalyticsLogsFailure = createAction(
  'downloadAnalyticsLogsFailure',
)
export const resetDownloadAnalyticsLogsState = createAction(
  'resetDownloadAnalyticsLogsState',
)
